import api from "Common/Client/Interceptor";

export const fetchSelfDashboardData = async () => {
  try {
    const response = await api.get("/indv/Dashboard/LearnerDashboard");  

    console.log("................ self learners data:", response.data);
    return response.data;
  } catch (error) {
    console.error(" Error self larner dashboard data:", error);
    throw error;
  }
};

export const fetchInterestData = async () => {
  try {
    const response = await api.get("/indv/CourseCategory/learner/get-interest");  

    console.log("................ self learners data:", response.data);
    return response.data;
  } catch (error) {
    console.error(" Error fetching interes data:", error);
    throw error;
  }
};
